<template>
  <div class="alliance">
    <!-- 标题栏 -->
    <van-nav-bar title="联盟商家" />
    <div class="page">
      <div class="disp_flex_between bgC-white" style="align-items: center;padding:10px 16px 10px 0;">
        <div class="address" :class="[trigger?'navigator-arrow-down':'navigator-arrow-up']" @click="switchTrigger">
          分类
        </div>
        <div class="search-group" @click="pageJump" :data-uri="'/pages/alliance/search/search'">
          <i class="iconfont icon-search"></i>
          搜索
        </div>
      </div>
      <div class="action-sheet" :class="[visible?'action-sheet-show':'']">
        <div class="class-item" :class="[item.isSelect?'active':'']" :data-id="item.id" v-for="(item,index) in allClass" :key="index" @click="select">{{item.text}}</div>
      </div>
      <div class="x-product-list">
        <div class="x-product-item" v-for="(item,index) in 5" :key="index" @click="pageJump('/merchant')">
          <img v-lazy="" class="x-product-object" />
          <div class="x-product-inner tl">
            <div class="x-product-title">灰熊先生</div>
            <div class="x-product-desc">内含<span v-if="true">3张卡</span>
              <span v-if="true">4张优惠券</span></div>
            <div class="x-product-footer">
              <span>教育</span>
              <span>距您100米</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部navbar -->
    <van-tabbar v-model="active" active-color="#4A4846" inactive-color="#9C9B9B">
      <van-tabbar-item :name="item.name" @click="switchTab(item)" v-for="(item,index) in navbars" :key="index">
        <span v-text="item.text"></span>
        <img slot="icon" slot-scope="props" :src="props.active ? item.active : item.normal" />
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'alliance',
  data () {
    return {
      tabActive: 0, // 当前展示哪个页面
      active: 1, // 当前展示哪个tab
      navbars: [
        {
          text: '首页',
          normal: './img/common/tabs/tab1.png',
          active: './img/common/tabs/tab1_HL.png'
        }, {
          text: '直播',
          normal: './img/common/tabs/tab2.png',
          active: './img/common/tabs/tab2_HL.png'
        },
        {
          text: '我的',
          normal: './img/common/tabs/tab3.png',
          active: './img/common/tabs/tab3_HL.png'
        }
      ],
      pageData: {}, // 页面数据
      allClass: [{
        id: 0,
        text: '全部',
        isSelect: false
      },
      {
        id: 1,
        text: 'bdc',
        isSelect: false
      }, {
        id: 2,
        text: 'cef',
        isSelect: false
      }, {
        id: 3,
        text: 'fgh',
        isSelect: false
      }, {
        id: 4,
        text: '2134',
        isSelect: false
      }
      ],
      trigger: true,
      isCollapse: false,
      visible: false
    }
  },
  created () {
    // const thisObj = this
    // thisObj.getData()
  },
  methods: {
    switchTab (item) {
      const thisObj = this
      let router = ''
      switch (item.text) {
        case '首页':
          router = '/'
          break
        case '直播':
          // router = '/alliance'
          break
        default:
          router = '/user'
      }
      thisObj.$router.push(router)
    },
    // 页面跳转
    pageJump (uri) {
      const thisObj = this
      let queryData = {}
      thisObj.$router.push({
        path: uri,
        query: queryData
      })
    },
    // 折叠面板开关事件
    switchTrigger () {
      console.log(1)
      this.trigger = !this.trigger
      this.isCollapse = !this.isCollapse
      this.visible = !this.visible
    },
    // 选择分类
    select (e) {
      const thisObj = this
      let id = e.target.dataset.id
      let allClass = thisObj.allClass
      for (let i in allClass) {
        if (id === 0) {
          allClass[i].isSelect = false
          allClass[0].isSelect = true
        } else if (id === allClass[i].id) {
          allClass[i].isSelect = true
        } else {
          allClass[i].isSelect = false
        }
      }
      // 关闭面板
      thisObj.switchTrigger()
      thisObj.allClass = allClass
      if (id === 0) { id = '' }
      // 查询数据的方法 写这里....
    }
  }
}
</script>
<style lang="css" scoped>
.disp-flex-between.bgC-white {
  z-index: 101;
  align-items: center;
  padding: 0 36px 20px 36px;
  box-shadow: 0px 6px 18px 0px rgba(216, 232, 253, 0.45);
}

.address {
  position: relative;
  width: 122px;
}

.address.navigator-arrow-up:before,
.address.navigator-arrow-down:before {
  right: 0px;
  margin-top: -13px;
  border-color: rgb(51, 51, 51);
}

.address.navigator-arrow-up:before {
  margin-top: -6px;
}

.search-group {
  width: 180px;
  height: 68px;
  line-height: 68px;
  padding-left: 20px;
  text-align: center;
  border-radius: 100px;
  font-size: 28px;
  color: #afafaf;
  background-color: #f7f7f7;
}

.search-group .icon-search {
  position: absolute;
  top: 0;
  left: 0;
}

.x-product-list {
  margin: 0 0 80px 0;
  padding: 0 30px;
}

.x-product-item {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  padding: 10px 20px 10px 25px;
  border-radius: 10px;
  background: #fff;
}

.x-product-item:first-child {
  margin-top: 40px;
}

.x-product-item:after {
  border: 0;
}

.x-product-item .x-product-inner {
  width: 100%;
}

.x-product-item .x-product-inner .x-product-title {
  padding: 17px 20px 19px 0;
  font-size: 32px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}

.x-product-item .x-product-inner .x-product-desc {
  font-size: 26px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
}

.x-product-item .x-product-inner .x-product-footer {
  position: absolute;
  bottom: 30px;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  width: 100%;
  padding-right: 34px;
  box-sizing: border-box;
}

.x-product-item .x-product-inner .x-product-footer span {
  font-size: 24px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: #dedede;
}
x- .x-product-item .x-product-inner .x-product-footer .fc-BBB {
  color: rgba(187, 187, 187, 1);
}

.x-product-item .x-product-inner .x-product-footer .line {
  width: 230px;
  height: 1px;
  margin: 20px 0;
  background: rgba(242, 242, 242, 1);
}

.action-sheet {
  /* position: fixed; */
  width: 100%;
  box-sizing: border-box;
  /* left: 0; */
  /* right: 0; */
  /* top: 89px; */
  padding: 32px 45px 20px 45px;
  min-height: 168px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 6px 18px 0px rgba(216, 232, 253, 0.45);
  transform: translate3d(0, 100%, 0);
  transform-origin: center;
  transition: all 0.2 ease-in-out;
  z-index: 10;
  display: none;
}

.action-sheet-show {
  transform: translate3d(0, 0, 0);
  display: block;
}

.action-sheet > .class-item {
  float: left;
  width: 100px;
  height: 60px;
  line-height: 60px;
  margin: 15px;
  text-align: center;
  border-radius: 100px;
  font-size: 28px;
  font-family: MicrosoftYaHeiLight;
  font-weight: 300;
  color: #b6b6b6;
  background: rgba(247, 247, 247, 1);
}

.action-sheet > .class-item.active {
  color: rgba(255, 255, 255, 1);
  background: rgba(248, 46, 61, 1);
}
</style>
